<template>
  <v-icon
    icon="mdi-loading"
    color="#244125"
    class="icon-spinner"
    size="x-large"
  />
</template>

<style scoped>
.icon-spinner {
  animation: spin-animation 1.5s infinite;
}

@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>

<script>
/* eslint-disable */
export default {
  name: "Loader",
  components: {},
  methods: {},
  mounted() {},
};
</script>
